import { reducer as toastrReducer } from "react-redux-toastr";
import { modal } from "@mc/mc-legacy";
import app from "./app";
export default {
  modalDialog: modal.ModalReducer,
  toastr: toastrReducer,
  app,
};
